import { API_BASE_URL } from '../config/api';

/**
 * iPhones and iPads play our recordings (Opus in WebM — the only thing Android
 * browsers can record) with static and dropouts. The same take as AAC plays
 * clean (A/B on Rob's iPhone, 2026-09-25). The server keeps an AAC copy of each
 * recording (backend/features/audioAac); on Apple devices, fetch that instead.
 */

// A recording on our CDN: submissions/<student or teacher>/<file>.webm
const RECORDING = /^https:\/\/videos\.littlelambenglish\.com\/submissions\/[A-Za-z0-9_-]+\/[A-Za-z0-9._-]+\.webm$/;

/** iPhone / iPad (any browser there is WebKit, WeChat included; iPadOS may say "Mac"), or Safari on a Mac. */
export function isAppleWebKit(nav = typeof navigator !== 'undefined' ? navigator : null) {
  if (!nav) return false;
  const ua = nav.userAgent || '';
  if (/iPhone|iPad|iPod/.test(ua)) return true;
  if (nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) return true; // iPad in desktop mode
  return /Safari\//.test(ua) && /Apple/.test(nav.vendor || '') && !/Chrome|Chromium|CriOS|Edg|OPR|Android/.test(ua);
}

/** The url to fetch to PLAY a recording on this device: the AAC copy on Apple, the original elsewhere. */
export function playableRecordingUrl(url, nav) {
  if (!url || !RECORDING.test(url) || !isAppleWebKit(nav)) return url;
  return `${API_BASE_URL}/audio/aac?src=${encodeURIComponent(url)}`;
}
